import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { updateArticlesPagination } from '../../../store/actions/article/article_action';
import { Typography, Button, Container, Grid, makeStyles } from '@material-ui/core';
import { REACT_ROUTES } from '../../../constants/react_routes';
import SearchComponent from '../../ui_components/search';
import history from '../../../services/history';
import ArticlesTable from './articles_table';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    alignCenter: {
        textAlign: 'center'
    }
}));

const ArticleList = ({ articles }) => {
    const { container, alignCenter } = useStyles();
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const { filters } = articles;

    useEffect(() => {
        if (filters?.search) {
            setSearch(filters.search);
        }
    }, []);

    const handleSearch = (e) => {
        const search = e.target.value;
        setSearch(search);
        dispatch(updateArticlesPagination({...articles, page: 0, filters: { ...filters, search }}))
    }

    const handleAddArticleClick = () => {
        history.push(REACT_ROUTES.ARTICLE);
    }

    return (
        <Container className={container}>
            <Typography variant="h4" align="center" gutterBottom>
                Usluge
            </Typography>
            <Grid container justify="center" spacing={1}>
                <SearchComponent value={search} handleSearch={handleSearch} />
                <Grid item xs={8} className={alignCenter}>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleAddArticleClick}
                    >
                        Kreirajte novu uslugu
                    </Button>
                </Grid>
                <ArticlesTable />
            </Grid>
        </Container>
    )
}

ArticleList.propTypes = {
    articles: PropTypes.object
}

const mapStateToProps = (state) => ({
    articles: state.articles
});

export default connect(mapStateToProps)(ArticleList);
